module.exports = {"371523001":"振兴街道","371523002":"信发街道","371523003":"温陈街道","371523101":"乐平铺镇","371523102":"冯官屯镇","371523103":"菜屯镇","371523104":"博平镇","371523105":"杜郎口镇","371523106":"韩屯镇","371523107":"胡屯镇","371523108":"肖庄镇","371523109":"贾寨镇","371523110":"洪官屯镇","371523208":"杨官屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371523.json
// module id = 1367
// module chunks = 0